
export const DEVICE_STATUS_TYPES = {
  available: 0,
  booked: 1,
  waitingForReturn: 2
}

export const DEVICE_STATUS_TYPES_ARR = ['available', 'booked', 'waitingForReturn'];

export const DEVICE_TYPE = {
  logistimatics_Mobile200: 0,
  logistimatics_Mobile310: 1
}

export const DEVICE_TYPE_ARR = ['logistimatics_Mobile200', 'logistimatics_Mobile310'];

export const DEVICE_FETCH_PARAMS = {
  name: 0,
  imei: 1,
  type: 2,
  status: 3,
  lastKnownBatteryLevel: 4,
  refreshRate: 5,
  unavailableUntil: 6,
  lastMoveName: 7
}

export const REFRESH_RATE_CHANGE_STATUS_ARR = ['pending', 'sent', 'received', 'failed'];

export const REFRESH_RATE_CHANGE_STATUS_PARAMS = {
  pending: 0,
  sent: 1,
  received: 2,
  failed: 3
}

export const REFRESH_RATE_CHANGE_STATUS = {
  0: 'pending',
  1: 'sent',
  2: 'received',
  3: 'failed'
}